document.addEventListener("DOMContentLoaded", (event) => {
  var modal = document.getElementById("offer-details-myModal");
  var detailButtons = document.querySelectorAll(".detailPop");
  var span = document.getElementsByClassName("offer-details-close")[0];

  // Attach click event to each .detailPop link
  detailButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      modal.style.display = "block";
    });
  });

  if (span) {
    span.onclick = function () {
      modal.style.display = "none";
    };
  } else {
    console.warn("Close button element '.offer-details-close' not found.");
  }

  window.onclick = function (event) {
    if (modal && event.target === modal) {
      modal.style.display = "none";
    }
  };
});
